(function () {
  var headerVipTokenStorageKey = 'vip_token';

  function hasVipSession() {
    try {
      return !!(
        localStorage.getItem(headerVipTokenStorageKey) ||
        sessionStorage.getItem(headerVipTokenStorageKey)
      );
    } catch {
      return false;
    }
  }

  function updateHeaderAccountLinks() {
    document.querySelectorAll('[data-vip-account-link]').forEach(function (link) {
      link.href = '/pages/profile';
      var label = link.querySelector('.visually-hidden');
      if (label) label.textContent = link.dataset.vipAccountLabel || 'Account';
      link.querySelectorAll('[data-vip-account]').forEach(function (el) {
        el.removeAttribute('hidden');
        el.removeAttribute('aria-hidden');
      });
      link.querySelectorAll('[data-vip-guest]').forEach(function (el) {
        el.setAttribute('hidden', '');
      });
    });
  }

  function initHeaderVipState() {
    if (!hasVipSession()) return;

    document.documentElement.classList.add('vip-authenticated');

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateHeaderAccountLinks);
    } else {
      updateHeaderAccountLinks();
    }
  }

  window.hasVipSession = hasVipSession;
  initHeaderVipState();
})();
